import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar } from "cakemail-ui-components/lib/react";
import { Translate, I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import BrandImage from "assets/js/scenes/brand/components/brandElements/BrandImage";
import { showResetDialog } from "assets/js/scenes/brand/utils";

const basePath = "images";
let key = new Date().getTime();
export const Illustrations = (props) => {
	const base = props.localBrand?.images;

	function reset() {
		function resetConfirm() {
			props.resetTabData(basePath, ["ill-"]);
			key = new Date().getTime();
		}

		showResetDialog(
			<Translate value="app-brand-modal-tab-illustration-reset" />,
			<p>
				<Translate
					value="app-brand-modal-tab-illustration-reset-desc"
					resellerName={props.resellerName}
				/>
			</p>,
			resetConfirm
		);
	}

	return (
		<div className="brandModalTabContent Illustrations" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tabs-illustration" />
					</p>
				}
				right={
					<Button
						shapeStyle="stroke"
						colorTheme="grey"
						text={<Translate value="app-brand-modal-tab-illustration-reset" />}
						onClick={reset}
					/>
				}
			/>

			<div className="brandElementsContainer">
				<BrandImage
					path={basePath + ".ill-empty-campaigns-drafts"}
					defaultImg={base["ill-empty-campaigns-drafts"]}
					imgName={<Translate value="app-brand-illustrations-draft-empty" />}
				/>
				<BrandImage
					path={basePath + ".ill-empty-campaigns-outbox"}
					defaultImg={base["ill-empty-campaigns-outbox"]}
					imgName={<Translate value="app-brand-illustrations-outbox-empty" />}
				/>
				<BrandImage
					path={basePath + ".ill-empty-campaigns-sent"}
					defaultImg={base["ill-empty-campaigns-sent"]}
					imgName={<Translate value="app-brand-illustrations-sent-empty" />}
				/>
			</div>
			<div className="brandElementsContainer">
				<BrandImage
					path={basePath + ".ill-empty-campaigns-templates"}
					defaultImg={base["ill-empty-campaigns-templates"]}
					imgName={<Translate value="app-brand-illustrations-template-empty" />}
				/>
				<BrandImage
					path={basePath + ".ill-empty-contacts"}
					defaultImg={base["ill-empty-contacts"]}
					imgName={<Translate value="app-brand-illustrations-contact-empty" />}
				/>
				<BrandImage
					path={basePath + ".ill-empty-forms"}
					defaultImg={base["ill-empty-forms"]}
					imgName={<Translate value="app-brand-illustrations-forms-empty" />}
				/>
			</div>
			<div className="brandElementsContainer">
				<BrandImage
					path={basePath + ".ill-empty-automations"}
					defaultImg={base["ill-empty-automations"]}
					imgName={
						<Translate value="app-brand-illustrations-automation-empty" />
					}
				/>
				<BrandImage
					path={basePath + ".ill-empty-listing"}
					defaultImg={base["ill-empty-listing"]}
					imgName={<Translate value="app-brand-illustrations-no-results" />}
				/>
				<BrandImage
					path={basePath + ".ill-add-contacts"}
					defaultImg={base["ill-add-contacts"]}
					imgName={<Translate value="app-brand-illustrations-add-contact" />}
				/>
			</div>
			<div className="brandElementsContainer">
				<BrandImage
					path={basePath + ".ill-workflow"}
					defaultImg={base["ill-workflow"]}
					imgName={
						<Translate value="app-brand-illustrations-automation-dashboard" />
					}
				/>
				<BrandImage
					path={basePath + ".ill-empty-ab-test-outbox"}
					defaultImg={base["ill-empty-ab-test-outbox"]}
					imgName={
						<Translate value="app-brand-illustrations-ab-test-outbox-empty" />
					}
				/>
				<BrandImage
					path={basePath + ".ill-empty-ab-test-drafts"}
					defaultImg={base["ill-empty-ab-test-drafts"]}
					imgName={
						<Translate value="app-brand-illustrations-ab-test-drafts-empty" />
					}
				/>
			</div>
			<div className="brandElementsContainer">
				<BrandImage
					path={basePath + ".ill-empty-ab-test-complete"}
					defaultImg={base["ill-empty-ab-test-complete"]}
					imgName={
						<Translate value="app-brand-illustrations-ab-test-complete-empty" />
					}
				/>
			</div>
		</div>
	);
};

Illustrations.propTypes = {
	updateBrandLocalData: PropTypes.func,
	localBrand: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
};

Illustrations.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				resellerName: state.brand?.name,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Illustrations)
);
